<template>
  <div>
    <div class="content">
      <div class="borderDiv" v-for="(meal, index) in mealInfo" :key="meal.id">
        <p class="title">第{{ index + 1 }}天</p>
        <div class="meal">
          <p class="title">套餐信息</p>
          <div v-for="food in meal.provideOrderMealss" :key="food.id">
            <div
              v-if="food.guidanceMeal && food.list.length > 0"
              class="container"
            >
              <div>
                <span v-if="food.guidanceMeal === 'breakfast'">早餐</span>
                <span v-if="food.guidanceMeal === 'lunch'">午餐</span>
                <span v-if="food.guidanceMeal === 'dinner'">晚餐</span>
                <span v-if="food.guidanceMeal === 'breakfastAdd'">早加餐</span>
                <span v-if="food.guidanceMeal === 'lunchAdd'">午加餐</span>
                <span v-if="food.guidanceMeal === 'dinnerAdd'">晚加餐</span>
              </div>
              <div>
                <span>{{ food.dinnerTime }}</span>
              </div>
              <div>
                <span v-for="(item, index) in food.list" :key="item.id">
                  {{
                    (index == food.list.length - 1 && item.name) ||
                    item.name + "，"
                  }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div class="food">
              <p class="title">食物信息（单位：克）</p>
              <div class="content" >
                <div v-for="food in meal.dayFoodTotal" :key="food.id">
                  <span>{{ food.foodName }}</span>
                  <p>{{ food.foodTotalNumber }}</p>
                </div>
              </div>
            </div>
            <div class="nutrition">
              <p class="title">营养信息</p>
              <div class="content">
                <div v-if="meal.calculation">
                  <span
                    >能量：{{
                      towNumber(meal.calculation.foodEnergy)
                    }}kcal</span
                  >
                  <span
                    >碳水：{{
                      towNumber(
                        meal.calculation.foodCarbohydrate
                      )
                    }}g</span
                  >
                  <span
                    >蛋白质：{{
                      towNumber(
                        meal.calculation.foodProtein
                      )
                    }}g</span
                  >
                  <span
                    >脂肪：{{
                      towNumber(meal.calculation.foodFat)
                    }}g</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { requestGuidance } from "@/api/guidance/guidance";
import { reactive, toRefs } from "vue";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";
import { DatetimePicker } from "vant";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const today = new Date();
    const tomorrow = today.setTime(today.getTime() + 24 * 60 * 60 * 1000);
    const state = reactive({
      id: route.params.id,
      mealInfo: [],
    });
   requestGuidance({ id: state.id }).then(v => {
      const { data } = v;
      const foodCalculate = data.foodCalculate;
      state.orderInfo = data;
      data.provideOrderDay.forEach((value, index) => {
        const calculation = {
          foodStatistics:{
            beans: 0,
            egg: 0,
            fruits: 0,
            meat: 0,
            milk: 0,
            nut: 0,
            oilOrfat: 0,
            other: 0,
            stapleFood: 2860,
            vegetable: 0,
          },
          foodEnergy: 0,
          foodFat: 0,
          foodCarbohydrate: 0,
          foodProtein: 0,
          foodStatisticsList: [],
        }
        value.dayFoodTotal = JSON.parse(value.dayFoodTotal);
        value.dayFoodIntake = JSON.parse(value.dayFoodIntake);
        value.provideOrderMealss.forEach(food => {
          food.list.forEach(guidanceMeal => {
            calculation.foodStatisticsList.push(JSON.parse(guidanceMeal.foodStatistics)[0]);
            calculation.foodEnergy += guidanceMeal.foodEnergy
            calculation.foodFat += guidanceMeal.foodFat
            calculation.foodCarbohydrate += guidanceMeal.foodCarbohydrate
            calculation.foodProtein += guidanceMeal.foodProtein
          })
        })
        // 计算食物
        calculation.foodStatisticsList.forEach(foodStatistics => {
          calculation.foodStatistics.beans += foodStatistics.beans
          calculation.foodStatistics.fruits += foodStatistics.fruits
          calculation.foodStatistics.egg += foodStatistics.egg
          calculation.foodStatistics.meat += foodStatistics.meat
          calculation.foodStatistics.milk += foodStatistics.milk
          calculation.foodStatistics.nut += foodStatistics.nut
          calculation.foodStatistics.oilOrfat += foodStatistics.oilOrfat
          calculation.foodStatistics.other += foodStatistics.other
          calculation.foodStatistics.stapleFood += foodStatistics.stapleFood
          calculation.foodStatistics.vegetable += foodStatistics.vegetable
        })
        value.dayFoodTotal.forEach(foodTotal => {
          let foodTotalNumber = null;
          calculation.foodStatisticsList.forEach(foodStatistics => {
            for(let i in foodStatistics) {
              if (i === 'stapleFood' && foodTotal.id === 1) {
                console.log(i, foodStatistics[i]);
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'vegetable' && foodTotal.id === 2) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'meat' && foodTotal.id === 3) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'egg' && foodTotal.id === 4) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'milk' && foodTotal.id === 5) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'beans' && foodTotal.id === 6) {
               foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'oilOrfat' && foodTotal.id === 7) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'fruits' && foodTotal.id === 8) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'nut' && foodTotal.id === 9) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'other' && foodTotal.id === 10) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              }
            }
          })
          console.log(foodTotal);
        });

        console.log(calculation);
        value.calculation = calculation;
      })
      state.mealInfo = data.provideOrderDay
      console.log(data);
    })
    // 保留两位小数
    const towNumber = (val) => {
      if (typeof val === "number") {
        return val.toFixed(2);
      } else {
        return parseFloat(val).toFixed(2);
      }
    };

    return {
      ...toRefs(state),
      requestGuidance,
      towNumber,
    };
  },
};
</script>
<style lang="scss" scoped>
.nutrition {
  opacity: 0.7;
  .content {
    display: flex;
    justify-items: center;
    padding: 5px 10px;
    span {
      margin-right: 10px;
    }
  }
}
.food {
  opacity: 0.7;
  .title {
    border-bottom: none !important;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    border: none;
    div {
      border: 1px solid var(--basic-border-color);
      width: 16%;
      text-align: center;
      span {
        display: inline-block;
        width: 100%;
        padding: 5px 0;
        border-bottom: 1px solid var(--basic-border-color);
      }
      p {
        padding: 8px 0;
      }
    }
  }
  p,
  span {
  }
}
.cateringDay {
  p:first-of-type {
    padding: 16px;
    color: #646566;
  }
}
.meal {
  opacity: 0.7;
  .borderDiv {
    border: 1px solid var(--basic-border-color);
    border-bottom: none;
    padding: 5px;
  }
  .container {
    display: flex;
    div {
      border-bottom: 1px solid var(--basic-border-color);
    }
    div:first-of-type {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid var(--basic-border-color);
    }
    div:nth-of-type(2) {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid var(--basic-border-color);
    }
    div:last-of-type {
      width: 70%;
      padding: 5px;
      display: flex;
      justify-items: center;
      flex-wrap: wrap;
      span {
        padding: 5px 0;
      }
    }
  }
}
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;
  .totalContent {
    .title {
      opacity: 0.5;
    }
    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      // background: ;
      text-align: left;
      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }
  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);
    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }
  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);
      span:first-of-type {
        color: var(--basic-labe);
      }
      div {
        display: flex;
        p {
          flex: 1;
        }
      }
    }
  }
}
.btnContent {
  padding: 20px 20px 0 20px;
  text-align: center;
  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
.seeInfoContent {
  padding: 10px 20px 20px 20px;
  text-align: center;
  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
